import React from 'react';
import { Table, Space, Input, Button, Tag, Typography } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { theme } from '../utils/theme';

const { Title, Text } = Typography;

const PatientList = ({ patients }) => {
  const patientColumns = [
    {
      title: 'Patient ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <Text strong>{text}</Text>
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'Active' ? theme.green : theme.gray}>
          {status}
        </Tag>
      )
    },
    {
      title: 'Next Appointment',
      dataIndex: 'appointment',
      key: 'appointment',
    },
    {
      title: 'Condition',
      dataIndex: 'condition',
      key: 'condition',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: () => (
        <Space>
          <Button size="small">View</Button>
          <Button size="small">Edit</Button>
        </Space>
      )
    }
  ];

  return (
    <>
      <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
        <Title level={4} style={{ margin: 0 }}>Patient List</Title>
        <Space>
          <Input 
            placeholder="Search patients..." 
            prefix={<SearchOutlined />}
            style={{ width: 250 }}
          />
          <Button type="primary" icon={<PlusOutlined />}>Add Patient</Button>
        </Space>
      </Space>
      <Table 
        columns={patientColumns}
        dataSource={patients}
        rowKey="id"
        pagination={{
          position: ['bottomRight'],
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          showTotal: (total) => `Showing ${patients.length} of ${total} patients`
        }}
      />
    </>
  );
};

export default PatientList;